var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "layout-widgets" },
    [
      _c(
        "div",
        {
          ref: "configContainer",
          staticClass:
            "d-flex justify-content-between align-items-center mb-3 position-relative",
        },
        [
          _c(
            "div",
            { staticClass: "d-flex align-items-center" },
            [
              _c("i", { staticClass: "fal fa-calendar-alt mr-2 text-muted" }),
              _vm._v(" "),
              _c("date-picker", {
                staticStyle: { width: "240px" },
                attrs: {
                  type: "date",
                  range: "",
                  "value-type": "YYYY-MM-DD",
                  format: "DD/MM/YYYY",
                  "range-separator": " - ",
                  editable: false,
                  clearable: false,
                },
                model: {
                  value: _vm.fechaRango,
                  callback: function ($$v) {
                    _vm.fechaRango = $$v
                  },
                  expression: "fechaRango",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", [
            _c(
              "button",
              {
                staticClass: "btn btn-sm btn-info shadow-sm mr-2",
                attrs: { title: "Actualizar datos", disabled: _vm.loading },
                on: { click: _vm.fetchDashboardStats },
              },
              [
                _c("i", {
                  staticClass: "fas fa-sync-alt fa-sm text-white-50 mr-1",
                  class: { "fa-spin": _vm.loading },
                }),
                _vm._v(" Actualizar\n      "),
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-sm btn-primary shadow-sm",
                on: {
                  click: function ($event) {
                    _vm.showConfig = !_vm.showConfig
                  },
                },
              },
              [
                _c("i", { staticClass: "fas fa-cog fa-sm text-white-50 mr-1" }),
                _vm._v(" Configurar Widgets\n      "),
              ]
            ),
          ]),
          _vm._v(" "),
          _vm.showConfig
            ? _c(
                "div",
                {
                  staticClass: "card shadow position-absolute",
                  staticStyle: {
                    top: "100%",
                    right: "0",
                    "z-index": "1000",
                    width: "320px",
                    "margin-top": "0.5rem",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "card-header py-3 d-flex flex-row align-items-center justify-content-between bg-white",
                    },
                    [
                      _c(
                        "h6",
                        { staticClass: "m-0 font-weight-bold text-primary" },
                        [_vm._v("Widgets Visibles")]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "close",
                          attrs: { type: "button", "aria-label": "Close" },
                          on: {
                            click: function ($event) {
                              _vm.showConfig = false
                            },
                          },
                        },
                        [
                          _c("span", { attrs: { "aria-hidden": "true" } }, [
                            _vm._v("×"),
                          ]),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "card-body",
                      staticStyle: {
                        "max-height": "400px",
                        "overflow-y": "auto",
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "input-group input-group-sm mb-3" },
                        [
                          _vm._m(0),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.widgetSearch,
                                expression: "widgetSearch",
                              },
                            ],
                            staticClass: "form-control border-left-0",
                            attrs: {
                              type: "text",
                              placeholder: "Buscar widget...",
                              "aria-label": "Buscar widget",
                            },
                            domProps: { value: _vm.widgetSearch },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.widgetSearch = $event.target.value
                              },
                            },
                          }),
                          _vm._v(" "),
                          _vm.widgetSearch
                            ? _c("div", { staticClass: "input-group-append" }, [
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-outline-secondary border-left-0",
                                    attrs: { type: "button", title: "Limpiar" },
                                    on: {
                                      click: function ($event) {
                                        _vm.widgetSearch = ""
                                      },
                                    },
                                  },
                                  [_c("i", { staticClass: "fal fa-times" })]
                                ),
                              ])
                            : _vm._e(),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "custom-control custom-switch mb-3 pb-2 border-bottom",
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.allWidgetsVisible,
                                expression: "allWidgetsVisible",
                              },
                            ],
                            staticClass: "custom-control-input",
                            attrs: {
                              type: "checkbox",
                              id: "switch-all",
                              disabled: _vm.saving,
                            },
                            domProps: {
                              checked: Array.isArray(_vm.allWidgetsVisible)
                                ? _vm._i(_vm.allWidgetsVisible, null) > -1
                                : _vm.allWidgetsVisible,
                            },
                            on: {
                              change: function ($event) {
                                var $$a = _vm.allWidgetsVisible,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.allWidgetsVisible = $$a.concat([
                                        $$v,
                                      ]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.allWidgetsVisible = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.allWidgetsVisible = $$c
                                }
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass:
                                "custom-control-label small font-weight-bold",
                              attrs: { for: "switch-all" },
                            },
                            [_vm._v("Activar Todos")]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.groupedFilteredWidgets, function (group) {
                        return [
                          _c(
                            "div",
                            {
                              key: "group-" + group.groupKey,
                              staticClass:
                                "text-uppercase small font-weight-bold text-muted mt-3 mb-2 pb-1 border-bottom",
                              staticStyle: { "letter-spacing": "0.05em" },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(group.groupLabel) +
                                  "\n          "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _vm._l(group.items, function ([key, config]) {
                            return _c(
                              "div",
                              {
                                key: "switch-" + key,
                                staticClass:
                                  "custom-control custom-switch mb-2",
                              },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: config.visible,
                                      expression: "config.visible",
                                    },
                                  ],
                                  staticClass: "custom-control-input",
                                  attrs: {
                                    type: "checkbox",
                                    id: "switch-" + key,
                                    disabled: _vm.saving,
                                  },
                                  domProps: {
                                    checked: Array.isArray(config.visible)
                                      ? _vm._i(config.visible, null) > -1
                                      : config.visible,
                                  },
                                  on: {
                                    change: [
                                      function ($event) {
                                        var $$a = config.visible,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = null,
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              _vm.$set(
                                                config,
                                                "visible",
                                                $$a.concat([$$v])
                                              )
                                          } else {
                                            $$i > -1 &&
                                              _vm.$set(
                                                config,
                                                "visible",
                                                $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1))
                                              )
                                          }
                                        } else {
                                          _vm.$set(config, "visible", $$c)
                                        }
                                      },
                                      function ($event) {
                                        return _vm.handleSingleChange(
                                          key,
                                          config.visible
                                        )
                                      },
                                    ],
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  {
                                    staticClass:
                                      "custom-control-label small font-weight-bold",
                                    attrs: { for: "switch-" + key },
                                  },
                                  [_vm._v(_vm._s(config.label))]
                                ),
                              ]
                            )
                          }),
                        ]
                      }),
                      _vm._v(" "),
                      _vm.totalFilteredCount === 0
                        ? _c(
                            "div",
                            {
                              staticClass: "text-muted small text-center py-2",
                            },
                            [
                              _vm._v(
                                '\n          Sin coincidencias para "' +
                                  _vm._s(_vm.widgetSearch) +
                                  '"\n        '
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    2
                  ),
                ]
              )
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _vm._l(_vm.widgetGroups, function (groupLabel, groupKey) {
        return [
          _vm.getVisibleTop5ByGroup(groupKey).length > 0
            ? [
                _c(
                  "div",
                  { key: "top5-header-" + groupKey, staticClass: "row mb-3" },
                  [
                    _c("div", { staticClass: "col-12" }, [
                      _c("h4", [_vm._v(_vm._s(groupLabel))]),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { key: "top5-row-" + groupKey, staticClass: "row" },
                  _vm._l(
                    _vm.getVisibleTop5ByGroup(groupKey),
                    function (widget) {
                      return _c(
                        "div",
                        {
                          key: widget.key,
                          staticClass: "col-md-3 col-sm-6 mb-4",
                        },
                        [
                          _c("WidgetTop5", {
                            attrs: {
                              title: widget.config.title,
                              subTitle: widget.config.subTitle,
                              items: Array.isArray(widget.data.total)
                                ? widget.data.total
                                : [],
                              groupTotal: widget.data.groupTotal,
                              variant: widget.config.variant,
                              loading: _vm.groupLoading(groupKey),
                            },
                          }),
                        ],
                        1
                      )
                    }
                  ),
                  0
                ),
              ]
            : _vm._e(),
        ]
      }),
      _vm._v(" "),
      _vm.filterKeys.length > 0
        ? _c(
            "b-row",
            { staticClass: "mb-3" },
            _vm._l(_vm.filterKeys, function (key) {
              return _c(
                "b-col",
                {
                  key: key,
                  staticClass: "mb-2",
                  attrs: { cols: "12", md: "6", lg: "3" },
                },
                [
                  _vm.activeFilters[key].filter_param === "id_carga_campana"
                    ? [
                        _c(
                          "div",
                          {
                            staticClass:
                              "p-3 border rounded bg-white shadow-sm d-flex align-items-center justify-content-between",
                          },
                          [
                            _c(
                              "label",
                              {
                                staticClass:
                                  "small font-weight-bold mb-0 text-dark",
                              },
                              [_vm._v(_vm._s(_vm.activeFilters[key].label))]
                            ),
                            _vm._v(" "),
                            _c("b-form-checkbox", {
                              staticClass: "ml-2",
                              attrs: { switch: "", size: "sm" },
                              model: {
                                value: _vm.cargasCampanasActive,
                                callback: function ($$v) {
                                  _vm.cargasCampanasActive = $$v
                                },
                                expression: "cargasCampanasActive",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    : _vm.activeFilters[key].filter_param === "id_carga_hora"
                    ? [
                        _c(
                          "div",
                          {
                            staticClass:
                              "p-3 border rounded bg-white shadow-sm d-flex align-items-center justify-content-between",
                          },
                          [
                            _c(
                              "label",
                              {
                                staticClass:
                                  "small font-weight-bold mb-0 text-dark",
                              },
                              [_vm._v(_vm._s(_vm.activeFilters[key].label))]
                            ),
                            _vm._v(" "),
                            _c("b-form-checkbox", {
                              staticClass: "ml-2",
                              attrs: { switch: "", size: "sm" },
                              model: {
                                value: _vm.cargasHorasActive,
                                callback: function ($$v) {
                                  _vm.cargasHorasActive = $$v
                                },
                                expression: "cargasHorasActive",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    : [
                        _c(
                          "label",
                          { staticClass: "small font-weight-bold mb-1" },
                          [_vm._v(_vm._s(_vm.activeFilters[key].label))]
                        ),
                        _vm._v(" "),
                        _c("Select2", {
                          attrs: {
                            value: _vm.selectedFilters[key] || [],
                            options: _vm.filterDropdownOptions(key),
                            multiple: true,
                            placeholder: _vm.activeFilters[key].placeholder,
                          },
                          on: {
                            input: function ($event) {
                              return _vm.setFilterValue(key, $event)
                            },
                          },
                        }),
                      ],
                ],
                2
              )
            }),
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.widgetGroups, function (groupLabel, groupKey) {
        return [
          _vm.getVisibleNumbersByGroup(groupKey).length > 0
            ? [
                _c(
                  "div",
                  { key: "num-header-" + groupKey, staticClass: "row mb-3" },
                  [
                    _c("div", { staticClass: "col-12" }, [
                      _c("h4", [_vm._v(_vm._s(groupLabel))]),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { key: "num-row-" + groupKey, staticClass: "row" },
                  _vm._l(
                    _vm.getVisibleNumbersByGroup(groupKey),
                    function (widget) {
                      return _c(
                        "div",
                        {
                          key: widget.key,
                          staticClass: "col-md-3 col-sm-6 mb-4",
                        },
                        [
                          _c("HomeWidget", {
                            attrs: {
                              title: widget.config.title,
                              subTitle: widget.config.subTitle,
                              value: widget.data.total,
                              variant: widget.config.variant,
                              to: widget.data.url,
                              loading: _vm.groupLoading(groupKey),
                            },
                          }),
                        ],
                        1
                      )
                    }
                  ),
                  0
                ),
              ]
            : _vm._e(),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text bg-white border-right-0" }, [
        _c("i", { staticClass: "fal fa-search text-muted" }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }